import { render, staticRenderFns } from "./asu.vue?vue&type=template&id=47d178f0"
import script from "./asu.vue?vue&type=script&lang=js"
export * from "./asu.vue?vue&type=script&lang=js"
import style0 from "./asu.vue?vue&type=style&index=0&id=47d178f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports